export default __webpack_public_path__ + "static/media/badge-verizon.88e41b49.png";